module.exports = __webpack_public_path__ + "img/office-365.5e35bd9f.svg";